import { Action, ActionCreator, ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { Middleware, MiddlewareAPI } from 'redux';
import { StoreData } from 'store/root-reducer';

export interface ActionHandler<T> {
  (_store: MiddlewareAPI<any, StoreData>, next: (action: T) => void, action: T): Promise<void> | void;
}

const actionMatches = (matcher: ActionCreator<unknown> | string, action: Action) =>
  (typeof matcher === 'string' && matcher === action.type) ||
  (typeof matcher !== 'string' && (matcher as ActionCreatorWithPayload<unknown>).match?.(action));

export const createMiddleware =
  (handlers: Map<ActionCreator<unknown> | string, ActionHandler<unknown>>): Middleware<any, StoreData> =>
  (store) =>
  (next) =>
  (action) => {
    next(action);
    handlers.forEach((handler, matcher) => {
      if (actionMatches(matcher, action)) {
        handler(store, next, action);
      }
    });
  };
